<div class="auth-back" *ngIf="isVisible$ | async" [ngClass]="{'-invisible': !(canNavBack$ | async)}">
    <div class="auth-back__inner">
        <shared-icon-btn (onClick)="handleClick($event)" icon="back-arrow" size="sm" class="auth-back__btn"
            title="back"></shared-icon-btn>
    </div>
</div>